/* ============================================================
   BONEANTHONY — Product Form JS (PDP)
   Loaded by sections/ba-main-product.liquid

   Responsibilities:
     - Variant picker (radio pills) → swap variant id, price, URL, availability
     - Quantity selector +/− handlers
     - AJAX add-to-cart with optimistic loading state
     - Update header cart count after success
     - Re-init on shopify:section:load
   ============================================================ */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  // ----------------------------------------------------------
  // Header cart count updater (mirrors ba-collection.js pattern)
  // ----------------------------------------------------------
  function updateHeaderCartCount(count) {
    var bubbles = $$('[data-cart-count-bubble], cart-icon-bubble, .ba-header__cart-count');
    bubbles.forEach(function (el) {
      var num = el.querySelector('[data-cart-count]') || el;
      if (count > 0) {
        num.textContent = count;
        el.classList.add('has-items');
        el.removeAttribute('hidden');
      } else {
        num.textContent = '';
        el.classList.remove('has-items');
      }
    });
  }

  // ----------------------------------------------------------
  // Format money — uses Shopify.formatMoney if available, else simple
  // ----------------------------------------------------------
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // ----------------------------------------------------------
  // Variant picker
  // ----------------------------------------------------------
  function initVariants(section) {
    var sectionId = section.dataset.sectionId;
    var jsonScript = section.querySelector('[data-ba-product-json]');
    if (!jsonScript) return;

    var product;
    try { product = JSON.parse(jsonScript.textContent); }
    catch (e) { console.error('[ba-product-form] JSON parse failed', e); return; }

    var variantInput = section.querySelector('[data-ba-variant-id]');
    var ctaBtn = section.querySelector('[data-ba-cta]');
    var ctaLabel = section.querySelector('[data-ba-cta-label]');
    var priceWrap = section.querySelector('.ba-mp__price');

    var fieldsets = $$('[data-ba-variants]', section);
    if (!fieldsets.length) return;

    function getSelectedOptions() {
      return fieldsets.map(function (fs) {
        var checked = fs.querySelector('input[type=radio]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      if (!product.variants) return null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v.options[j] !== opts[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function updatePriceMarkup(variant) {
      if (!priceWrap) return;
      if (!variant) return;

      // If a discount badge was rendered server-side, recompute it for the new variant.
      // The price element exposes the badge label via data-discount-label and the
      // sold-out label via data-soldout-label.
      var discountLabel = priceWrap.dataset.discountLabel || '';
      var soldoutLabel = priceWrap.dataset.soldoutLabel || 'Sold out';
      var serverHadBadge = !!priceWrap.querySelector('.ba-mp__discount-badge');
      var parts = [];

      var isSale = variant.available && variant.compare_at_price && variant.compare_at_price > variant.price;

      if (serverHadBadge && isSale && discountLabel) {
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        parts.push('<span class="ba-mp__discount-badge">' + discountLabel + ' ' + pct + '%</span>');
      }

      if (!variant.available) {
        parts.push('<span class="ba-mp__price-soldout">' + soldoutLabel + '</span>');
      } else if (isSale) {
        parts.push('<span class="ba-mp__price-mrp">' + formatMoney(variant.compare_at_price) + '</span>');
        parts.push('<span class="ba-mp__price-sale">' + formatMoney(variant.price) + '</span>');
      } else {
        parts.push('<span class="ba-mp__price-regular">' + formatMoney(variant.price) + '</span>');
      }

      priceWrap.innerHTML = parts.join('');
    }

    function updateUrl(variant) {
      if (!variant || !window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    function updateVariantState() {
      var opts = getSelectedOptions();
      var variant = findVariant(opts);

      // Update legend "selected value" text
      fieldsets.forEach(function (fs) {
        var checked = fs.querySelector('input[type=radio]:checked');
        var current = fs.querySelector('[data-ba-variant-current]');
        if (checked && current) current.textContent = checked.value;
        // Update is-selected visual state
        $$('label.ba-mp__variant-pill', fs).forEach(function (label) {
          var input = label.querySelector('input');
          if (input && input.checked) label.classList.add('is-selected');
          else label.classList.remove('is-selected');
        });
      });

      if (!variant) {
        if (ctaBtn) ctaBtn.disabled = true;
        if (ctaLabel) ctaLabel.textContent = 'Unavailable';
        return;
      }

      if (variantInput) variantInput.value = variant.id;

      if (ctaBtn) {
        ctaBtn.disabled = !variant.available;
      }
      if (ctaLabel) {
        ctaLabel.textContent = variant.available
          ? (ctaBtn && ctaBtn.dataset.labelAvailable) || ctaLabel.dataset.original || ctaLabel.textContent
          : 'Sold out';
      }

      updatePriceMarkup(variant);
      updateUrl(variant);

      // Notify any listeners (e.g. Shopify Pay button)
      section.dispatchEvent(new CustomEvent('ba:variant:change', { detail: { variant: variant }, bubbles: true }));
    }

    // Bind change events
    fieldsets.forEach(function (fs) {
      $$('input[type=radio]', fs).forEach(function (input) {
        input.addEventListener('change', updateVariantState);
      });
    });

    // Cache the original CTA label so we can restore it after sold-out swaps
    if (ctaLabel && !ctaLabel.dataset.original) {
      ctaLabel.dataset.original = ctaLabel.textContent.trim();
    }
  }

  // ----------------------------------------------------------
  // Quantity selector
  // ----------------------------------------------------------
  function initQuantity(section) {
    var input = section.querySelector('[data-ba-qty-input]');
    var dec = section.querySelector('[data-ba-qty-decrement]');
    var inc = section.querySelector('[data-ba-qty-increment]');
    if (!input) return;

    function clamp(n) {
      var min = parseInt(input.min || '1', 10);
      return Math.max(min, n);
    }

    if (dec) {
      dec.addEventListener('click', function () {
        input.value = clamp((parseInt(input.value, 10) || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (inc) {
      inc.addEventListener('click', function () {
        input.value = clamp((parseInt(input.value, 10) || 1) + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  // ----------------------------------------------------------
  // AJAX add-to-cart
  // ----------------------------------------------------------
  function initFormSubmit(section) {
    var form = section.querySelector('[data-ba-product-form]');
    if (!form) return;
    if (form.dataset.baBound === '1') return;
    form.dataset.baBound = '1';

    var btn = form.querySelector('[data-ba-cta]');
    var label = form.querySelector('[data-ba-cta-label]');
    var errorEl = form.querySelector('[data-ba-form-error]');

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
      setTimeout(function () { errorEl.hidden = true; }, 4000);
    }

    form.addEventListener('submit', function (e) {
      if (!btn || btn.disabled) return;
      e.preventDefault();

      btn.classList.add('is-loading');
      btn.disabled = true;

      var formData = new FormData(form);

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        },
        body: formData
      })
        .then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          if (!res.ok || (res.data.status && res.data.status >= 400)) {
            showError(res.data.description || res.data.message || 'Could not add to cart.');
            btn.classList.remove('is-loading');
            btn.disabled = false;
            return;
          }
          // Success — flash success, refresh cart count, optionally open cart drawer
          if (label) {
            var orig = label.dataset.original || label.textContent;
            label.textContent = 'Added';
            setTimeout(function () {
              label.textContent = orig;
              btn.classList.remove('is-loading');
              btn.disabled = false;
            }, 1400);
          }
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              updateHeaderCartCount(cart.item_count);
              // Open cart drawer if present
              var drawer = document.querySelector('cart-drawer, [data-cart-drawer], #CartDrawer');
              if (drawer && typeof drawer.open === 'function') {
                drawer.open();
              } else if (drawer) {
                drawer.classList.add('is-open');
                drawer.setAttribute('open', '');
              }
              // Notify listeners
              document.dispatchEvent(new CustomEvent('ba:cart:added', { detail: { cart: cart }, bubbles: true }));
            });
        })
        .catch(function (err) {
          console.error('[ba-product-form]', err);
          showError('Network error. Please try again.');
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
    });
  }

  // ----------------------------------------------------------
  // Mobile gallery dots — sync with horizontal scroll position
  // ----------------------------------------------------------
  function initGalleryDots(section) {
    var gallery = section.querySelector('[data-ba-gallery]');
    var dotsWrap = section.querySelector('[data-ba-gallery-dots]');
    if (!gallery || !dotsWrap) return;
    var dots = $$('[data-index]', dotsWrap);
    var items = $$('[data-index]', gallery);
    if (!dots.length || !items.length) return;

    function update() {
      var scrollLeft = gallery.scrollLeft;
      var w = gallery.clientWidth;
      // active = the item whose center is closest to the gallery's center
      var center = scrollLeft + w / 2;
      var bestIdx = 0;
      var bestDist = Infinity;
      items.forEach(function (item, i) {
        var c = item.offsetLeft + item.offsetWidth / 2;
        var d = Math.abs(c - center);
        if (d < bestDist) { bestDist = d; bestIdx = i; }
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === bestIdx);
      });
    }

    // Throttle scroll handler with rAF
    var rafId = null;
    gallery.addEventListener('scroll', function () {
      if (rafId) return;
      rafId = requestAnimationFrame(function () { update(); rafId = null; });
    }, { passive: true });

    // Click a dot → scroll the matching item into view
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var item = items[i];
        if (!item) return;
        gallery.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      });
    });

    // First paint
    update();
  }

  // ----------------------------------------------------------
  // Section init
  // ----------------------------------------------------------
  function initSection(section) {
    initVariants(section);
    initQuantity(section);
    initFormSubmit(section);
    initGalleryDots(section);
  }

  function init() {
    $$('[data-ba-mp]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on theme editor section load
  document.addEventListener('shopify:section:load', function (e) {
    var sec = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (!sec) return;
    var mp = sec.querySelector('[data-ba-mp]');
    if (mp) {
      // Reset binding flag to allow re-init
      var form = mp.querySelector('[data-ba-product-form]');
      if (form) form.dataset.baBound = '';
      initSection(mp);
    }
  });
})();
